import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Button } from '../components';

const titleColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.reallyLightBlue,
});

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.midLightGrey,
});

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.white,
  dark: (props) => props.theme.colors.lpGhost,
});

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.midLightGrey,
  dark: (props) => props.theme.colors.softGrey,
});

const Text = styled(Flex)`
  font-weight: 300;
  line-height: 1.5;
  color: ${textColor};
`;

const Title = styled(Text)`
  line-height: 1.1;
  color: ${titleColor};
`;

const BannerContainer = styled(Box)`
  background-color: ${backgroundColor};
`;

const IconWrapper = styled(Flex)`
  color: ${iconColor};
`;

const ICON_SIZE = 70;

function Banner(props) {
  const {
    title, content, Icon, history, to, ...otherProps
  } = props;

  const handleLearnMoreClick = () => history.push(to);

  return (
    <BannerContainer p={4} mb={4} {...otherProps}>
      <Flex alignItems="center">
        <Box fontSize={1} flex={[1, 2, 4]}>
          <Title fontSize={3} fontWeight={400} mb={2}>
            {title}
          </Title>
          <Text mb={4}>{content}</Text>
          <Button variant="secondary" onClick={handleLearnMoreClick}>
            {`Go to ${title}`}
          </Button>
        </Box>

        <IconWrapper height={ICON_SIZE} width={ICON_SIZE} ml={4} flex={1} justifyContent="center">
          <Icon
            title={title}
            alt={title}
            height={ICON_SIZE}
            width={ICON_SIZE}
          />
        </IconWrapper>
      </Flex>
    </BannerContainer>
  );
}

Banner.defaultProps = {
  swapSides: false,
  title: undefined,
  content: undefined,
  Icon: undefined,
};

Banner.propTypes = {
  swapSides: PropTypes.bool,
  to: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  Icon: PropTypes.object,
};

export default Banner;
